import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MaterialModule} from './material/material.module';
import {StoreModule} from '@ngrx/store';
import {effects, reducers} from './store';
import {EffectsModule} from '@ngrx/effects';
import {ToastListComponent} from './containers';
import {
  ToastItemComponent,
  FormFieldComponent,
  LoaderComponent,
  SuccessDialogWindowComponent,
  IntlTelInputModule, ExternalRedirectComponent,
} from './components';
import {MatTableModule} from '@angular/material/table';
import {MatSelectModule} from '@angular/material/select';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {
  VarDirective,
  CtrlClickDirective,
  ShowErrorDirective,
  DndDirective,
} from './directives';
import {DateAdapter, MatNativeDateModule} from '@angular/material/core';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {TranslateModule} from '@ngx-translate/core';
import {CustomDateAdapter} from './components/custom-date-adapter/custom-date-adapter';
import {CoreService} from '@app/core/services';
import {Subject, takeUntil} from 'rxjs';

@NgModule({
  declarations: [
    ToastListComponent,
    ToastItemComponent,
    ExternalRedirectComponent,
    FormFieldComponent,
    SuccessDialogWindowComponent,
    LoaderComponent,
    ShowErrorDirective,
    DndDirective,
    VarDirective,
    CtrlClickDirective,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    MaterialModule,
    MatDatepickerModule,
    MatNativeDateModule,
    StoreModule.forFeature('shared', reducers),
    EffectsModule.forFeature(effects),
  ],
  providers: [{provide: DateAdapter, useClass: CustomDateAdapter}],

  exports: [
    VarDirective,
    DndDirective,
    FormsModule,
    ShowErrorDirective,
    IntlTelInputModule,
    ReactiveFormsModule,
    FormFieldComponent,
    LoaderComponent,
    MaterialModule,
    ToastListComponent,
    MatTableModule,
    MatSelectModule,
    ToastItemComponent,
    CtrlClickDirective,
  ],
})
export class SharedModule {
  destroyed$ = new Subject<boolean>();

  constructor(
    private dateAdapter: DateAdapter<Date>,
    private coreService: CoreService
  ) {
    this.coreService.addLocale$
      .pipe(takeUntil(this.destroyed$))
      .subscribe((locale) => {
        this.dateAdapter.setLocale(locale);
      });
  }
}
